module.exports = __webpack_public_path__ + "static/media/gd.ab061a1f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/gd.svg
// module id = 123
// module chunks = 0